import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'tire-add-dot-number',
  templateUrl: './tire-add-dot-number.component.html',
  styleUrls: ['./tire-add-dot-number.component.scss'],
})
export class TireAddDotNumberComponent implements OnInit {
  @Input() data: any = {};
  @Output() onInputChange = new EventEmitter<any>();
  @Output() onSwitchBtnChange = new EventEmitter<any>();

  tirePositions: any[] = [
    {
      label: 'Front Left',
      value: 'FL',
    },
    {
      label: 'Front Right',
      value: 'FR',
    },
    {
      label: 'Rear Left',
      value: 'RL',
    },
    {
      label: 'Rear Right',
      value: 'RR',
    },
    {
      label: 'Spare',
      value: 'S1',
    },
  ];

  ngOnInit(): void {}

  handleChange(event: any, item) {
    if (!event) {
      item.tirePosition = '';
    }

    this.onInputChange.emit({ value: event, item });
  }

  onCardTypeSelect(event: any, item: any) {
    this.onSwitchBtnChange.emit({ data: event, item });
  }

  getTireLabel(value: any) {
    let tireLabel: any = value;
    switch (value) {
      case 'FL': {
        tireLabel = { label: 'Front Left', value };
        break;
      }
      case 'FR': {
        tireLabel = { label: 'Front Right', value };
        break;
      }
      case 'RL': {
        tireLabel = { label: 'Rear Left', value };
        break;
      }
      case 'RR': {
        tireLabel = { label: 'Rear Right', value };
        break;
      }
      case 'S1': {
        tireLabel = { label: 'Spare', value };
        break;
      }
      case 'S2': {
        tireLabel = { label: 'Spare', value };
        break;
      }
    }

    return tireLabel;
  }
}
